export default {"src":"/_next/static/media/font-scale.885327af.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};